import { Bar, BarChart, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { chartTooltipProps } from "@/components/charts/ChartTooltip";

export interface BreakdownItem {
  label: string;
  value: number;
}

const VIZ_CLASS = "dolfin-user-activity-viz";

/** Single-series bars, so one hue: palette slot 1 as in DocumentVolumeChart, scoped here. */
export const USER_ACTIVITY_VIZ_STYLES = `
.${VIZ_CLASS} {
  --series-1: #2a78d6;
  --series-2: #eb6834;
}
.dark .${VIZ_CLASS} {
  --series-1: #3987e5;
  --series-2: #d95926;
}
`;
export const USER_ACTIVITY_VIZ_CLASS = VIZ_CLASS;


/** Top `max` items plus an "Other" bar for the rest, largest first. */
export function topWithOther(items: BreakdownItem[], max: number): BreakdownItem[] {
  const sorted = [...items].sort((a, b) => b.value - a.value);
  if (sorted.length <= max) return sorted;
  const rest = sorted.slice(max).reduce((sum, item) => sum + item.value, 0);
  return [...sorted.slice(0, max), { label: "Other", value: rest }];
}

/** Horizontal bars with the count printed at the end, so no axis needs reading. */
export function BreakdownBars({ title, items }: { title: string; items: BreakdownItem[] }) {
  const height = Math.max(items.length, 1) * 26 + 8;
  return (
    <div>
      <p className="text-muted-foreground mb-1 text-xs font-medium tracking-wide uppercase">{title}</p>
      {items.length === 0 ? (
        <p className="text-muted-foreground text-sm">None</p>
      ) : (
        <div style={{ height }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={items} layout="vertical" margin={{ top: 0, right: 40, bottom: 0, left: 0 }} barCategoryGap={4}>
              <XAxis type="number" hide allowDecimals={false} />
              <YAxis
                type="category"
                dataKey="label"
                width={128}
                tick={{ fontSize: 12 }}
                tickLine={false}
                axisLine={false}
                stroke="var(--color-muted-foreground, #6b7280)"
              />
              <Tooltip {...chartTooltipProps} />
              <Bar dataKey="value" name="Sign-ins" fill="var(--series-1)" radius={[0, 3, 3, 0]}>
                <LabelList dataKey="value" position="right" fontSize={11} fill="var(--color-muted-foreground, #6b7280)" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
